import { render } from "./BackerCenterDashboardView.vue?vue&type=template&id=2b06f322"
import script from "./BackerCenterDashboardView.vue?vue&type=script&lang=js"
export * from "./BackerCenterDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__